/**
 * Contrato master por fornecedor (FornecedoresContratosMasters).
 * API / enum: Pendente = 1, Assinado = 2 (enumFornecedoresContratosMastersStatusAssinatura).
 */

export function resolveFornecedorContratoMasterStatus(row) {
  const raw =
    row?.statusAssinatura ??
    row?.StatusAssinatura ??
    row?.status ??
    row?.Status;

  if (raw === undefined || raw === null || raw === '') {
    return { key: 'unknown', label: '—' };
  }

  const n = Number(raw);
  if (Number.isFinite(n)) {
    if (n === 2) return { key: 'assinado', label: 'Assinado' };
    if (n === 1) return { key: 'pendente', label: 'Pendente' };
  }

  const s = String(raw).trim().toLowerCase();
  if (s === 'assinado' || s === 'signed' || s === '2') {
    return { key: 'assinado', label: 'Assinado' };
  }
  if (s === 'pendente' || s === 'pending' || s === '1') {
    return { key: 'pendente', label: 'Pendente' };
  }

  return { key: 'unknown', label: String(raw) };
}

export function isFornecedorContratoMasterAssinado(row) {
  return resolveFornecedorContratoMasterStatus(row).key === 'assinado';
}

/** resposta pode ser array direto ou objeto com itens / Itens. */
export function normalizeContratosMastersAssinadosLista(resposta) {
  if (!resposta) return [];
  if (Array.isArray(resposta)) return resposta;
  if (Array.isArray(resposta.itens)) return resposta.itens;
  if (Array.isArray(resposta.Itens)) return resposta.Itens;
  return [];
}
